'use strict';

var cov_27nqgd5m45 = function () {
  var path = '/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/resaleAvailability/lib/reducer.js',
      hash = '9c52526531704234c403760aa6c0631af9a04d82',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/resaleAvailability/lib/reducer.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 39
        },
        end: {
          line: 10,
          column: 1
        }
      },
      '1': {
        start: {
          line: 12,
          column: 35
        },
        end: {
          line: 16,
          column: 1
        }
      },
      '2': {
        start: {
          line: 18,
          column: 16
        },
        end: {
          line: 42,
          column: 1
        }
      },
      '3': {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 41,
          column: 3
        }
      },
      '4': {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 25,
          column: 8
        }
      },
      '5': {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 27,
          column: 68
        }
      },
      '6': {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 33,
          column: 8
        }
      },
      '7': {
        start: {
          line: 35,
          column: 6
        },
        end: {
          line: 38,
          column: 8
        }
      },
      '8': {
        start: {
          line: 40,
          column: 6
        },
        end: {
          line: 40,
          column: 19
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 18,
            column: 16
          },
          end: {
            line: 18,
            column: 17
          }
        },
        loc: {
          start: {
            line: 18,
            column: 92
          },
          end: {
            line: 42,
            column: 1
          }
        },
        line: 18
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 18,
            column: 17
          },
          end: {
            line: 18,
            column: 79
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 18,
            column: 25
          },
          end: {
            line: 18,
            column: 79
          }
        }],
        line: 18
      },
      '1': {
        loc: {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 41,
            column: 3
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 25,
            column: 8
          }
        }, {
          start: {
            line: 26,
            column: 4
          },
          end: {
            line: 33,
            column: 8
          }
        }, {
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 38,
            column: 8
          }
        }, {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 40,
            column: 19
          }
        }],
        line: 20
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0
    },
    f: {
      '0': 0
    },
    b: {
      '0': [0],
      '1': [0, 0, 0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _model = require('./model');

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resaleAvailabilityInitialState = (cov_27nqgd5m45.s[0]++, {
  isDisplayResaleLink: false,
  resaleProductUrl: '',
  resalePassUrl: '',
  resalePerformanceUrl: '',
  supportedProductTypes: [],
  supportedProductFamilySubTypes: []
});

var catalogReducerInitialState = (cov_27nqgd5m45.s[1]++, {
  LOADING: false,
  ERROR: false,
  resaleAvailability: resaleAvailabilityInitialState
});

cov_27nqgd5m45.s[2]++;
var catalog = function catalog() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_27nqgd5m45.b[0][0]++, JSON.parse((0, _stringify2.default)(catalogReducerInitialState)));
  var action = arguments[1];
  cov_27nqgd5m45.f[0]++;

  var resaleAvailability = void 0;
  cov_27nqgd5m45.s[3]++;
  switch (action.type) {
    case 'RESALE_AVAILABILITY_LOAD':
      cov_27nqgd5m45.b[1][0]++;
      cov_27nqgd5m45.s[4]++;

      return {
        LOADING: true,
        ERROR: false
      };
    case 'RESALE_AVAILABILITY_LOAD_SUCCESS':
      cov_27nqgd5m45.b[1][1]++;
      cov_27nqgd5m45.s[5]++;

      resaleAvailability = _model2.default.get(action.data);
      cov_27nqgd5m45.s[6]++;
      return (0, _extends3.default)({}, state, {
        resaleAvailability: resaleAvailability,
        LOADING: false,
        ERROR: false
      });
    case 'RESALE_AVAILABILITY_LOAD_ERROR':
      cov_27nqgd5m45.b[1][2]++;
      cov_27nqgd5m45.s[7]++;

      return {
        LOADING: false,
        ERROR: true
      };
    default:
      cov_27nqgd5m45.b[1][3]++;
      cov_27nqgd5m45.s[8]++;

      return state;
  }
};

exports.default = catalog;